export enum SurveyTemplateEditPageStep {
  details = "details",
  questions = "questions",
}
